var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeaturesIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Solutions",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 4730,
    transform: "translate(-288 -1040)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Features",
    clipPath: "url(#clip1_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 512,
    transform: "translate(-288 -260)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Section"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Container"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Container_2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -168,
    y: -24,
    width: 384,
    height: 212,
    rx: 32,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Features icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.7656 19.7754H15.0996C13.0709 19.7742 11.0805 20.3288 9.34471 21.3789C7.60891 22.4291 6.19396 23.9348 5.2535 25.7324C4.31304 27.53 3.88301 29.5509 4.01009 31.5757C4.13717 33.6005 4.81652 35.5517 5.97436 37.2177L4.69236 40.8926C4.66259 40.9778 4.65944 41.07 4.68332 41.1571C4.70721 41.2441 4.757 41.3218 4.82609 41.3799C4.89517 41.4379 4.98028 41.4736 5.07012 41.4821C5.15996 41.4907 5.25028 41.4717 5.32908 41.4277L8.38268 39.7233C10.3109 41.199 12.6715 41.9985 15.0996 41.9981H21.7656C23.226 42 24.6725 41.7141 26.0223 41.1565C27.3721 40.599 28.5988 39.7809 29.6322 38.7489C30.6655 37.7169 31.4853 36.4914 32.0446 35.1423C32.604 33.7932 32.8919 32.3471 32.8919 30.8867C32.8919 29.4263 32.604 27.9802 32.0446 26.6312C31.4853 25.2821 30.6655 24.0565 29.6322 23.0246C28.5988 21.9926 27.3721 21.1744 26.0223 20.6169C24.6725 20.0594 23.226 19.7734 21.7656 19.7754Z",
    fill: "#C3A0FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.9219 32.7305C12.9402 32.7305 13.7656 31.905 13.7656 30.8867C13.7656 29.8684 12.9402 29.043 11.9219 29.043C10.9036 29.043 10.0781 29.8684 10.0781 30.8867C10.0781 31.905 10.9036 32.7305 11.9219 32.7305Z",
    fill: "#F2F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.4336 32.7305C19.4519 32.7305 20.2774 31.905 20.2774 30.8867C20.2774 29.8684 19.4519 29.043 18.4336 29.043C17.4153 29.043 16.5898 29.8684 16.5898 30.8867C16.5898 31.905 17.4153 32.7305 18.4336 32.7305Z",
    fill: "#DBC6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M24.9414 32.7305C25.9597 32.7305 26.7852 31.905 26.7852 30.8867C26.7852 29.8684 25.9597 29.043 24.9414 29.043C23.9231 29.043 23.0977 29.8684 23.0977 30.8867C23.0977 31.905 23.9231 32.7305 24.9414 32.7305Z",
    fill: "#DBC6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M42.2929 23.3606C43.4297 21.6908 44.0897 19.7426 44.2019 17.7256C44.314 15.7086 43.8741 13.6992 42.9294 11.9137C41.9846 10.1281 40.5709 8.63393 38.8403 7.59193C37.1097 6.54993 35.1278 5.99955 33.1077 6.00001H26.4417C24.9814 5.99805 23.535 6.28398 22.1853 6.84145C20.8357 7.39892 19.6091 8.21699 18.5758 9.24888C17.5426 10.2808 16.7228 11.5062 16.1636 12.8552C15.6043 14.2041 15.3164 15.6501 15.3164 17.1104C15.3164 18.5706 15.6043 20.0166 16.1636 21.3656C16.7228 22.7145 17.5426 23.94 18.5758 24.9718C19.6091 26.0037 20.8357 26.8218 22.1853 27.3793C23.535 27.9367 24.9814 28.2227 26.4417 28.2207H33.1077C35.5518 28.2213 37.9271 27.4115 39.862 25.9181L42.9671 27.6504C43.0456 27.6943 43.1357 27.7133 43.2253 27.7048C43.3149 27.6964 43.3998 27.6609 43.4688 27.603C43.5378 27.5452 43.5875 27.4678 43.6115 27.381C43.6354 27.2942 43.6324 27.2022 43.6028 27.1172L42.2929 23.3606Z",
    fill: "#9B62FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M30.8457 15.7129H24.2578C23.9926 15.7129 23.7382 15.6075 23.5507 15.42C23.3632 15.2325 23.2578 14.9781 23.2578 14.7129C23.2578 14.4477 23.3632 14.1933 23.5507 14.0058C23.7382 13.8182 23.9926 13.7129 24.2578 13.7129H30.8457C31.1109 13.7129 31.3653 13.8182 31.5528 14.0058C31.7403 14.1933 31.8457 14.4477 31.8457 14.7129C31.8457 14.9781 31.7403 15.2325 31.5528 15.42C31.3653 15.6075 31.1109 15.7129 30.8457 15.7129Z",
    fill: "#F2F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M35.29 20.5078H24.2578C23.9926 20.5078 23.7382 20.4025 23.5507 20.2149C23.3632 20.0274 23.2578 19.773 23.2578 19.5078C23.2578 19.2426 23.3632 18.9882 23.5507 18.8007C23.7382 18.6132 23.9926 18.5078 24.2578 18.5078H35.29C35.5553 18.5078 35.8096 18.6132 35.9971 18.8007C36.1847 18.9882 36.29 19.2426 36.29 19.5078C36.29 19.773 36.1847 20.0274 35.9971 20.2149C35.8096 20.4025 35.5553 20.5078 35.29 20.5078Z",
    fill: "#F2F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M38.1719 37.998C40.381 37.998 42.1719 36.2072 42.1719 33.998C42.1719 31.7889 40.381 29.998 38.1719 29.998C35.9627 29.998 34.1719 31.7889 34.1719 33.998C34.1719 36.2072 35.9627 37.998 38.1719 37.998Z",
    fill: "#DBC6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M9.90234 18.1582C12.1115 18.1582 13.9023 16.3673 13.9023 14.1582C13.9023 11.9491 12.1115 10.1582 9.90234 10.1582C7.6932 10.1582 5.90234 11.9491 5.90234 14.1582C5.90234 16.3673 7.6932 18.1582 9.90234 18.1582Z",
    fill: "#DBC6FF"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -167.5,
    y: -23.5,
    width: 383,
    height: 211,
    rx: 31.5,
    stroke: "#2F2B43",
    strokeOpacity: 0.1
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 4730,
    fill: "white",
    transform: "translate(-288 -1040)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 512,
    fill: "white",
    transform: "translate(-288 -260)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesIcons);
export default __webpack_public_path__ + "static/media/FeaturesIcons.508c79ffc5be0831754ef1f06f6ba011.svg";
export { ForwardRef as ReactComponent };